import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from "react-toastify";

function Leads({ clients = [], onClientDeleted, openEditClientForm }) {

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    if (window.confirm("Are you sure you want to delete this client?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/Leads/${id}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
     
        toast.success("Client deleted successfully.");
        onClientDeleted && onClientDeleted(); // Optional callback to refresh list
      } catch (error) {
        console.error("Error deleting client:", error);
        toast.error("Failed to delete client");
      }
    }
  };

  if (!clients.length) {
    return <div className='text-white'>No Leads found.</div>;
  }

  return (
    <div className="space-y-3">
      {clients.map((client) => (
        <div
          key={client._id}
          className="flex flex-col md:flex-row items-start bg-white rounded-lg shadow-sm border p-4 mb-3"
        >
          <div className="flex justify-center items-center w-20 md:w-24 bg-gray-100 rounded-lg p-3 mb-3 md:mb-0">
            👤 Client
          </div>

          <div className="flex-1 ml-3">
            <h5 className="text-lg font-semibold">{client.LeadsName || 'Unnamed Client'}</h5>
            <p className="mb-1">
              <strong>Lead Type:</strong> {client.leadType || '—'}
            </p>
            <p className="mb-1">
              <strong>Email:</strong> {client.Email || '—'}
            </p>
            <p>
              <strong>Contact:</strong> {client.contact || '—'}
            </p>
          </div>

          <div className="flex flex-col gap-2 mt-3 md:mt-0 ml-auto">
            <button
              onClick={() => openEditClientForm(client)}
              className="btn btn-sm bg-blue-500 text-white py-1 px-3 rounded-lg hover:bg-blue-600 focus:outline-none"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(client._id)}
              className="btn btn-sm bg-red-500 text-white py-1 px-3 rounded-lg hover:bg-red-600 focus:outline-none"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Leads;
